import PropTypes from 'prop-types';
import React from 'react';

function sortByCategory(features) {
  const categories = {};
  const alphabetical = {};
  features.forEach(feature => {
    if (!Object.keys(categories).includes(feature.category)) {
      categories[feature.category] = [];
    }
    categories[feature.category].push(<p key={feature.key}>{feature.display}</p>);
  });
  Object.keys(categories)
    .sort()
    .forEach(key => {
      alphabetical[key] = categories[key];
    });
  return alphabetical;
}

class HotelDetailFeatures extends React.Component {
  render() {
    const { features } = this.props;
    if (!features) {
      return null;
    }
    // const popular = [];
    // const general = [];
    // const activities = [];
    // const internet = [];
    // const services = [];
    // const policy = [];
    // const parking = [];
    const sections = [];

    const categories = sortByCategory(features);
    // features.forEach(feature => {
    //   if (feature.category === 'General') {
    //     general.push(<li>{feature.display}</li>);
    //   }
    //   if (feature.category === 'Internet') {
    //     internet.push(<li>{feature.display}</li>);
    //   }
    //   if (feature.category === 'Activites') {
    //     activities.push(<li>{feature.display}</li>);
    //   }
    //   if (feature.category === 'Service') {
    //     services.push(<li>{feature.display}</li>);
    //   }
    //   if (feature.category === 'Parking') {
    //     parking.push(<li>{feature.display}</li>);
    //   }
    //
    //   if (feature.category === 'Policy') {
    //     policy.push(<li>{feature.display}</li>);
    //   }
    //   if (feature.popular > 0) {
    //     popular.push(<li>{feature.display}</li>);
    //   }
    // });

    for (const category in categories) {
      if (category !== '') {
        sections.push(
          <div className="col-md-4" key={category}>
            <h4>{category}</h4>
            {categories[category]}
          </div>
        );
      }
    }
    return <div>{sections}</div>;
  }
}

HotelDetailFeatures.propTypes = {
  features: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default HotelDetailFeatures;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelDetailFeatures.js